import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';


@Component({
    selector: 'ramastanheader',
    template: require('./ramastanheader.component.html'),
    styles: [require('./ramastanheader.component.css')],
    encapsulation: ViewEncapsulation.None
    //    './css/drop_down_menus.css',
    //    './css/ie51_menu_hack.css',
    //    './css/clearfix.css'        
    
})
export class RamastanHeaderComponent implements OnInit {
    fullImagePath: string;
    fullbannerImagePath: string;
   

    constructor(private router: Router,
        private route: ActivatedRoute) {
        
        this.fullImagePath = "./dist/ramastangifs/ram5c.gif";
        this.fullbannerImagePath = "./dist/ramastangifs/Ramban002loop.gif";
    }
    ngOnInit() {

    }
   
    


}
   


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/ramastanheader/ramastanheader.component.ts